import { useLocation, useHistory, Redirect } from "react-router-dom";
import { FullscreenTakeover } from "@jsq/ds/core";
import { globalEnv } from "~/global-env";
import { type RoleState } from "~/pages/Compliance/CaseDetailsDrawer/Profiles/common/AutoProfileCreationCard";
import CreateIndividualForm from "~/pages/Compliance/CaseDetailsDrawer/Profiles/OwnersAndControllersCard/CreateOwnersAndControllersFullscreenTakeover/CreateIndividualForm";

interface Props {
  caseId: number;
  investingProfileId: number | undefined;
}

const INITIAL_ROLE_VALUES: RoleState = {
  isOwner: true,
  isController: false,
  ownershipPercentage: 0,
};

const JointChildOwner = ({ caseId, investingProfileId }: Props) => {
  const history = useHistory();
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const parentProfileIdParam = searchParams.get("parentProfileId");
  const parsedParamId = parentProfileIdParam ? parseInt(parentProfileIdParam, 10) : NaN;
  const parentProfileId = Number.isFinite(parsedParamId) ? parsedParamId : investingProfileId;

  const profilesPath = `${globalEnv.complianceRoute}/case/${caseId}/profiles`;

  if (parentProfileId === undefined) {
    return <Redirect to={profilesPath} />;
  }

  const navigateToProfiles = () => {
    history.push(profilesPath);
  };

  return (
    <FullscreenTakeover>
      <FullscreenTakeover.Header title="New child owner" onExit={navigateToProfiles} />
      <FullscreenTakeover.Body>
        <CreateIndividualForm
          caseId={caseId}
          parentProfileId={parentProfileId}
          inAiExtractionMode={false}
          isChildOfJointAccount
          initialRoleValues={INITIAL_ROLE_VALUES}
          navigateOnCancel={navigateToProfiles}
          navigateOnCompletion={navigateToProfiles}
        />
      </FullscreenTakeover.Body>
    </FullscreenTakeover>
  );
};

export default JointChildOwner;
